import Config from 'services/config/config';
import { SHOW_HIDE_TOAST } from 'services/redux/sales/appNotifications/type';
import { store } from 'services/redux/store';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { getProfile } from 'services/redux/auth/login/action';
import { GET_PROFILE } from 'services/redux/auth/login/type';
import { DISTANCE_DETAILS } from 'services/redux/DistanceCalculator/type';
import {
  MEETING_HISTORY,
  POC_LIST_DROPDOWN,
  MEETING_BY_ID,
  VIEW_MOM,
  FEEDBACK,
  FEEDBACK_BY_ID,
  GET_INVOICES,
  CHEQUE_PICKED_LIST,
  SAVE_AS_DRAFT_DATA,
  DISCARD_DRAFT,
  CHECK_IN_MEETING,
  CX_ORDER_REFUND_LIST, 
  CX_ORDER_REFUND_DATA, 
  CX_ORDER_REFUND_APPROVAL, 
  USERS_LIST_FOR_HOD,
  SAVE_USER_RATING_BY_HOD,
  USER_DATA_BY_USER_ID,
  GET_JUNIOR_LIST,
  SAVE_MEETING_RATING_BY_SENIOR,
  EMAIL_DROPDOWN_FILTER,
  SELF_SCORECARD_BY_HOD,
  SELF_SCORECARD_BY_SENIOR,
  NCS_MEETINGS,
  NCS_MEETINGS_DATA
} from './type';

/** Refresh DutyBar after meeting complete / checkout — profile holds active_distance_checkin. */
export const refreshAfterMeetingComplete = () => async (dispatch, getState) => {
  dispatch({ type: DISTANCE_DETAILS, payload: {} });
  await dispatch(getProfile());
  const profile = getState()?.loginReducer?.userProfile || {};
  const active = profile.active_distance_checkin;
  if (active && active.module_type === 'Meeting Tracker') {
    dispatch({
      type: GET_PROFILE,
      payload: { ...profile, active_distance_checkin: null },
    });
  }
};

export const getMeetingList = (siteId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.meetingList}?site_id=${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: MEETING_HISTORY, payload: data.response.data });
    return data.response.data;
  }
};

export const getMeetingLists = (filterData = null, page = 1) => async (dispatch) => {
  
  
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null
      ? `${Config.brandActivation.meetingLists}?page=${page}`
      : `${Config.brandActivation.meetingLists}?site_no=${filterData.site_no}&client_name=${filterData.client_name}&agenda=${filterData.agenda}&page=${page}&ba_name=${filterData.ba_name}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: MEETING_HISTORY, payload: data.response.data });
    return data.response.data;
  }
};

export const getChequePickedList = (page) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.getChequePickedList}?page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CHEQUE_PICKED_LIST, payload: data.response.data });
    return data.response.data;
  }
};

export const getFeedback = (filterData = null, page = 1) => async (dispatch) => {
  
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null
      ? `${Config.brandActivation.getFeedback}?page=${page}`
      : `${Config.brandActivation.getFeedback}?ba_name=${filterData.ba_name}&client_name=${filterData.client_name}&agenda=${filterData.agenda}&page=${page}`
  );
  // console.log(res); return false;
  if (res) {
    const { data } = res;
    dispatch({ type: FEEDBACK, payload: data.response.data });
    return data.response.data;
  }
};


export const getFeedbackById = (feedbackId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.feedbackById}?id=${feedbackId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: FEEDBACK_BY_ID, payload: data.response.data });
    return data.response.data;
  }
};

export const getPocList = (siteId, meetingId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.meetingPoc}?site_id=${siteId}&meeting_id=${meetingId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: POC_LIST_DROPDOWN, payload: data.response.data });
    return data.response.data;
  }
};

export const createMeeting = (requestData, draftStatus, draftId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    `${Config.brandActivation.createMeeting}?draft_status=${draftStatus}&draft_id=${draftId}`
  );
  if (res?.data?.response?.status === true) {
    // draft_status=2 = submit/complete meeting — refresh check-in bar
    if (Number(draftStatus) === 2) {
      await dispatch(refreshAfterMeetingComplete());
    }
    return res?.data?.response;
  } else {
    return false;
  }
};

export const saveDraftMeeting = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.saveMeetingAsDraft
  );
  if (res?.data?.response?.status === true) {
    return res?.data?.response;
  } else {
    return false;
  }
};

export const saveCheckinForMeeting = (requestData) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.saveMeetingCheckIn
  );
  const ok =
    res?.data?.status === 0 ||
    res?.data?.response?.status === true;
  if (ok) {
    await dispatch(getProfile());
    return res?.data?.response ?? { status: true, data: res?.data?.data };
  } else {
    return false;
  }
};

export const updateMeeting = (requestData) => async (dispatch) => {
  const res = await callWebService(
    callTypes.put,
    requestData,
    Config.brandActivation.updateMeeting
  );
  if (res?.data?.response?.status === true) {
    await dispatch(refreshAfterMeetingComplete());
    return true;
  } else return false;
};

export const getMeetingById = (meetingId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.meetingById}?id=${meetingId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: MEETING_BY_ID, payload: data.response.data });
    return data.response.data;
  }
};

export const getInvoiceList = (siteId, documentType) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.getInvoicesMappedToSite}?site_id=${siteId}&document_type=${documentType}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: GET_INVOICES, payload: data.response.data });
    return data.response.data;
  }
};


export const cancelMeeting = (meetingId) => async () => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.cancelMeeting}?meeting_id=${meetingId}`
  );
  if (res?.data?.response?.status === false) {
    store.dispatch({
      type: SHOW_HIDE_TOAST,
      payload: { isToast: true, toastMessage: res?.data?.message },
    });
  }
  if (res?.data?.response?.status === true) {
    return true;
  } else return false;
};

export const completeMeeting = (meetingId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.completeMeeting}?meeting_id=${meetingId}`
  );
  if (res?.data?.response?.status === true) {
    await dispatch(refreshAfterMeetingComplete());
    return true;
  }
};

export const createMom = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.brandActivation.meetingMomAdd
  );
  if (res?.data?.response?.status === true) {
    return true;
  }
};

export const getMomBymeetingId = (meetingId) => async (dispatch) => {
  dispatch({ type: VIEW_MOM, payload: null });
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.meetingMomView}?meeting_id=${meetingId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: VIEW_MOM, payload: data.response.data });
    return data.response.data;
  }
};


export const getSaveAsDraftData = (draftId) => async (dispatch) => {
  const res = await callWebService(
      callTypes.get,
      "",
      `${Config.brandActivation.meetingDraftList}?draft_id=${draftId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SAVE_AS_DRAFT_DATA, payload: data.response.data });
    return data.response.data;
  }
}
export const cxOrderRefundList = (category_ids, status, role_id) => async (dispatch) => {
  dispatch({ type: CX_ORDER_REFUND_LIST, payload: null });
  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.cxOrderRefundList}?category_ids=${category_ids}&status=${status}&role_id=${role_id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CX_ORDER_REFUND_LIST, payload: data.response.data });
    return data.response.data;
  }
};


export const discardDraftMeeting = () => async () => {
  const res = await callWebService(
    callTypes.post,
    "",
    Config.brandActivation.discardMeetingDraft
  );
  if (res?.data?.response?.status === true) {
    return res?.data?.response;
  } else {
    return false;
  }
};



export const cxOrderRefundData = (order_id, id, role_id) => async (dispatch) => {
  dispatch({ type: CX_ORDER_REFUND_DATA, payload: null });
  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.cxOrderData}?order_id=${order_id}&id=${id}&role_id=${role_id}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CX_ORDER_REFUND_DATA, payload: data.response.data });
    return data.response.data;
  }
};

export const cxOrderRefundApproval = (data) => async (dispatch) => {
  dispatch({ type: CX_ORDER_REFUND_APPROVAL, payload: null });
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.refundApproval}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: CX_ORDER_REFUND_APPROVAL, payload: data.response });
    return data.response;
  }
};

export const getUserListsHod = (filterData = null, page = 1) => async (dispatch) => {
  
  
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null
      ? `${Config.brandActivation.usersListForHod}?page=${page}`
      : `${Config.brandActivation.usersListForHod}?user_name=${filterData.user_name}&from_date=${filterData.from_date}&to_date=${filterData.to_date}&month=${filterData.month}&page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: USERS_LIST_FOR_HOD, payload: data.response });
    return data.response;
  }
};

export const saveTheUserRating = (data) => async (dispatch) => {
  dispatch({ type: SAVE_USER_RATING_BY_HOD, payload: null });
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.brandActivation.saveUserRatingByHod}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SAVE_USER_RATING_BY_HOD, payload: data.response });
    return data.response;
  }
};


export const userDataByUserId = (userId, meetingId) => async (dispatch) => {
  dispatch({ type: USER_DATA_BY_USER_ID, payload: null });
  
  // Construct the URL based on the presence of userId and meetingId
  let url = `${Config.brandActivation.getUserDataByUserId}`;
  if (userId) {
      url += `?user_id=${userId}`;
  }
  if (meetingId) {
      url += (userId ? '&' : '?') + `meeting_id=${meetingId}`;
  }

  try {
      const res = await callWebService(callTypes.get, '', url);
      if (res) {
          const { data } = res;
          dispatch({ type: USER_DATA_BY_USER_ID, payload: data.response.data });
          return data.response.data;
      }
  } catch (error) {
      dispatch({ type: USER_DATA_BY_USER_ID, payload: null });
  }
};


export const juniorListForImmediateSenior = (filterData = null, page = 1) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null
      ? `${Config.brandActivation.getJuniorListForImmediateSenior}?page=${page}`
      : `${Config.brandActivation.getJuniorListForImmediateSenior}?user_name=${filterData.user_name}&from_date=${filterData.from_date}&to_date=${filterData.to_date}&month=${filterData.month}&page=${page}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: GET_JUNIOR_LIST, payload: data.response });
    return data.response;
  }
};

export const saveTheMeetingRating = (data) => async (dispatch) => {
  dispatch({ type: SAVE_MEETING_RATING_BY_SENIOR, payload: null });
  const res = await callWebService(
      callTypes.post,
      data,
      `${Config.brandActivation.saveMeetingRatingBySenior}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SAVE_MEETING_RATING_BY_SENIOR, payload: data.response });
    return data.response;
  }
};

export const fetchRatingEmailDropdown = (type="hod") => async (dispatch) => {
  dispatch({ type: EMAIL_DROPDOWN_FILTER, payload: null });
  const res = await callWebService(
      callTypes.get,
      '',
      `${Config.brandActivation.emailDropdownForRating}?type=${type}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: EMAIL_DROPDOWN_FILTER, payload: data.response.data });
    return data.response.data;
  }
};


export const fetchSelfScorecardByHod = (filterData = null) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null
      ? `${Config.brandActivation.selfScorecardByHod}`
      : `${Config.brandActivation.selfScorecardByHod}?month=${filterData.month}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SELF_SCORECARD_BY_HOD, payload: data.response.data });
    return data.response.data;
  }
};

export const fetchSelfScorecardBySenior = (filterData = null) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    filterData === null
      ? `${Config.brandActivation.selfScorecardBySenior}`
      : `${Config.brandActivation.selfScorecardBySenior}?from_date=${filterData.from_date}&to_date=${filterData.to_date}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: SELF_SCORECARD_BY_SENIOR, payload: data.response.data });
    return data.response.data;
  }
};

export const getNcsMeetings = () => async (dispatch) => {
  dispatch({ type: NCS_MEETINGS, payload: null });
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.getNcsMeetings}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: NCS_MEETINGS, payload: data.response.data });
    return data.response.data;
  }
};

export const getNcsMeetingbyId = (meetingId,status) => async (dispatch) => {
  dispatch({ type: NCS_MEETINGS_DATA, payload: null });
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.brandActivation.getNcsMeetingbyId}?meeting_id=${meetingId}&status=${status}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: NCS_MEETINGS_DATA, payload: data.response.data });
    
    return data.response.data;
  }
};

export const saveAndCheckoutNCSMeeting = (payload) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    payload,
    `${Config.brandActivation.saveAndCheckoutNCSMeeting}`
  );

  if (res) {
    const { data } = res;
    if (data?.response?.status) {
      await dispatch(refreshAfterMeetingComplete());
    }
    return data.response;
  }
};

export const saveAndCheckInNCSMeeting = (payload) => async (dispatch) => {
  const res = await callWebService(
    callTypes.post,
    payload,
    `${Config.brandActivation.saveAndCheckInNCSMeeting}`
  );

  if (res) {
    const { data } = res;
    if (data?.response?.status || data?.status === 0) {
      await dispatch(getProfile());
    }
    return data.response;
  }
};

